import React, { useContext, useEffect, useState } from "react";
//
import { useNavigate, useParams, useLocation } from "react-router-dom";
// 語系
import { useIntl } from "react-intl";
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
//
import Selection from "../../common/components/input/Selection";
// config
import { I18N_SETTING } from "../../i18n/config.locale";

const LocaleSwitch = () => {
  //
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  const { locale } = useParams();

  //
  const intl = useIntl();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { locale: userLocale } = state.user;
  // local state
  const [localLocale, setLocalLocale] = useState(userLocale);

  useEffect(() => {
    let isPathNameWithLocale = false;
    let urlLocale;
    I18N_SETTING.filter((item) => item.public)
      .map((item) => item.value)
      .forEach((item) => {
        if (pathname.indexOf(item) > -1) {
          isPathNameWithLocale = true;
          urlLocale = item;
        }
      });

    // pathname 若有帶 locale, 則以 pathname 的 locale 為主
    if (isPathNameWithLocale && urlLocale) {
      setLocalLocale(urlLocale);
    }

    // pathname 若沒有帶 locale,在 pathname 加入 locale
    if (!isPathNameWithLocale) {
      navigate(`/${userLocale}${pathname}${search}`);
    }
  }, [userLocale]);

  useEffect(() => {
    if (localLocale) {
      dispatch({
        type: Act.SET_USER_LOCALE,
        payload: localLocale,
      });
    }
  }, [localLocale]);

  const options = I18N_SETTING.filter((item) => item.public).map((item) => ({
    value: item.value,
    label: item.label,
  }));

  const handleLocaleChange = (e) => {
    const { value } = e.target;
    dispatch({
      type: Act.SET_USER_LOCALE,
      payload: value,
    });
    // change path by locale
    navigate(`${pathname.replace(locale, value)}${search}`);
  };

  return (
    <Selection
      options={options}
      inputProps={{
        value: [localLocale],
        placeholder: intl.formatMessage({
          id: "header.locale",
          defaultMessage: "語系",
        }),
        onChange: handleLocaleChange,
      }}
      MenuProps={{}}
      sx={{ width: "90px", height: "35px" }}
    />
  );
};

export default LocaleSwitch;
